import { createBlueprint as t } from "@made-people/blueprint";
const e = t({
  slots: {
    overlay: "fixed top-0 left-0 size-full bg-black/60 z-[41] opacity-100 transition-opacity"
  },
  variants: {}
});
export {
  e as overlayBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
